<template>
  <div>
    <v-banner></v-banner>
    <service-center></service-center>
    <bottom></bottom>
  </div>
</template>

<script>
import Banner from "@/views/Home/common/banner";
import ServiceCenter from "@/views/Home/common/ServiceCenter";
import bottom from "@/components/bottom";
export default {
  components: {
    "v-banner": Banner,
    "service-center": ServiceCenter,
    bottom
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue